export const palette = {
  color_mainText: "#000000",
  color_subText: "#8C8C8C",
  color_margin: "#edeff1",
  color_barFill: "#717FFE",
  color_barBack: "#D5D8DC",
  color_barInside: "#0000004d",
  color_background: "#F5F7F9",
  color_white: "#FFFFFF",
  color_plus: "#FF3B30",
  color_minus: "#3182F6",
};
